import React from "react";

const SubmissionNameHelp = () => {
  return (
    <div>
      The submission name is a name for a batch of variant interpretations.
      <ul>
        <li>
          Any submission may have a submission name, but it is required if you
          provide either a study name or a study description.
        </li>
        <li>
          A submission name is particularly useful if you are submitting a large
          set of records to ClinVar to be referenced in a publication.
          <ul>
            <li>
              You can reference both the submission name and your ClinVar
              accession numbers in your paper.
            </li>
            <li>
              {" "}
              We recommend use of a submission name, because providing a range
              of accessions may not make each of your records as discoverable in
              ClinVar.
            </li>
          </ul>
        </li>
        <li>
          The submission name is not displayed on the website, but you can
          search for it as [Submitter Batch]
          <ul>
            <li>
              You can reference both the submission name and your ClinVar
              accession numbers in your paper. e.g. search for EGL003[Submitter
              Batch]
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default SubmissionNameHelp;
